import classNames from 'classnames';
import { type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type PaneItemTWProps = {
  className?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  avatar: ReactNode;
  buttons: ReactNode;
  truncate?: boolean;
  previewLoader?: ReactNode;
};

export const PaneItemTW = ({
  className,
  title,
  subtitle,
  avatar,
  buttons,
  truncate = true,
  previewLoader,
}: PaneItemTWProps) => {
  const hasSubtitle = Boolean(subtitle);

  return (
    <div
      className={cn(
        'm-0 flex content-between p-4 ui2026:px-4 ui2026:py-3 text-left',
        hasSubtitle ? 'ui2026:items-center' : 'ui2026:items-stretch',
        className,
      )}
    >
      <div className="shrink-0">{previewLoader}</div>
      <div
        className={cn('flex min-w-0 grow items-center', hasSubtitle ? 'ui2026:items-start' : 'ui2026:items-stretch')}
      >
        <div className={cn('shrink-0', !hasSubtitle && 'ui2026:self-start')}>{avatar}</div>
        <div
          className={classNames(
            'min-w-0 flex-1',
            !hasSubtitle && 'ui2026:flex ui2026:flex-col ui2026:justify-center',
            truncate && '[&>*]:truncate',
          )}
        >
          {title}
          {subtitle}
        </div>
      </div>
      <div className="ml-2 flex shrink-0 content-end ui2026:items-center gap-2.5 ui2026:gap-1 ui2026:pl-2.5">
        {buttons}
      </div>
    </div>
  );
};
